import React, { Component } from "react";

import MainMenu from "./components/mainMenu";
import TopBanner from "./components/topBanner";
import SubNavigation from "./components/subNavigation";
export default class NotFound extends Component {
	render() {
		return (
			<React.Fragment>
				<MainMenu />
				<TopBanner
					bannerHeight="full"
					title="404 Not Found"
					images={["luge/lugeBanner.jpg"]}
				/>
				<SubNavigation
					location={this.props.location}
					refs={this.refs}
					navItems={[
						{
							title: "Sorry, The page you are looking for can not be found.",
							id: "error"
						}
					]}
				/>
			</React.Fragment>
		);
	}
}
